import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Footer from "../../../Footer";
import {
  show_loader,
  hide_loader,
  set_user_details,
  set_buiness_list,
} from "../../../actions/app";
import _ from "lodash";
import api_requests from "../../../resources/api_requests";
import utils from "../../../resources/utils";
import constant from "../../../resources/constant";
import Loader from "../../../modules/Loader";

const Signup = ({ data }) => {
  const { is_loading } = useSelector((state) => state.app, shallowEqual);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formData, setformData] = useState({
    name: data?.name || "",
    biz_name: "",
    email: data?.email || "",
    mobile: data?.mobile || "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setformData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handle_submit = async (e) => {
    e.preventDefault();
    try {
      dispatch(show_loader());
      const payload = {
        authId: data?.authId,
        ptm_token: data?.ptm_token,
        name: formData.name,
        email: formData.email,
        mobile: formData.mobile,
        brand_name: formData.biz_name,
      };
      const response = await api_requests.save_paytm_brand_data(payload);
      if (response?.data?.token) {
        utils._storeData(constant.AUTH_TOKEN, response?.data?.token);
        const data = {
          first_name: response?.data?.info?.first_name,
          last_name: response?.data?.info?.last_name,
          email: response?.data?.info?.meta_info?.email,
          mobile: response?.data?.info?.mobile,
        };
        utils._storeData(constant.USER_DETIALS, data);

        dispatch(set_user_details(data));
        dispatch(set_buiness_list(response?.data?.info?.business_info));
        dispatch(hide_loader());
        navigate("/business-select", { replace: true });
      }
      dispatch(hide_loader());
    } catch (error) {
      dispatch(hide_loader());
    }
  };

  const btn_disable = useMemo(() => {
    let value = true;
    if (
      formData.name != "" &&
      formData.biz_name != "" &&
      formData.email != "" &&
      formData.mobile.length == 10
    ) {
      value = false;
    }
    return value;
  }, [formData]);

  return (
    <>
      {is_loading && <Loader />}
      <div className="min-h-screen px-6 py-6 overflow-hidden max-h-[100vh]">
        <div className="flex flex-col items-center mt-7">
          <p className="font-custom font-semibold text-2xl text-primary">
            Sign Up!
          </p>

          <p className="font-custom font-medium text-xs mt-1 text-center mx-10 text-center">
            Get started with your quick deliveries
          </p>
        </div>

        <div
          className="rounded-lg mt-10 pb-11 overflow-auto"
          style={{
            boxShadow: `0px 0px 8px 0px #A6A6A640`,
          }}
        >
          <form onSubmit={handle_submit} className="pl-6 pr-6 pt-6 space-y-4">
            <div className="form-control">
              <label
                htmlFor="name"
                className="font-custom label-text mb-2 font-semibold text-secondary"
              >
                Full Name*
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                readOnly={!_.isEmpty(data.name)}
                onChange={handleInputChange}
                className="font-custom bg-gray-50 border border-accents text-sm rounded-lg focus:ring-accents focus:border-accents block w-full p-2.5 focus:outline-accents "
                placeholder="Enter your full name here"
              />
            </div>

            <div className="form-control">
              <label
                htmlFor="biz_name"
                className="font-custom label-text mb-2 font-semibold text-secondary"
              >
                Business Name*
              </label>
              <input
                type="text"
                id="biz_name"
                name="biz_name"
                value={formData.biz_name}
                onChange={handleInputChange}
                className="font-custom bg-gray-50 border border-accents text-sm rounded-lg focus:ring-accents focus:border-accents block w-full p-2.5 focus:outline-accents "
                placeholder="Enter your business name"
              />
            </div>
            <div className="form-control">
              <label
                htmlFor="email"
                className="font-custom label-text mb-2 font-semibold text-secondary"
              >
                Email*
              </label>
              <input
                type="text"
                id="email"
                name="email"
                readOnly={!_.isEmpty(data.email)}
                value={formData.email}
                onChange={handleInputChange}
                className="font-custom bg-gray-50 border border-accents text-sm rounded-lg focus:ring-accents focus:border-accents block w-full p-2.5 focus:outline-accents "
                placeholder="Eg; yourname@gmail.com"
              />
            </div>
            <div className="form-control">
              <label
                htmlFor="mobile"
                className="font-custom label-text mb-2  font-semibold text-secondary"
              >
                Sender's Number*
              </label>
              <div className="flex gap-1">
                <input
                  type="number"
                  id="mobile"
                  name="mobile"
                  readOnly={!_.isEmpty(data.mobile)}
                  value={formData.mobile}
                  onChange={handleInputChange}
                  className="font-custom bg-gray-50 border border-accents text-sm rounded-lg focus:ring-accents focus:border-accents block w-full p-2.5 focus:outline-accents "
                  placeholder="Enter 10 digit contact number"
                />
              </div>
            </div>

            <div className="form-control" style={{ marginTop: "40px" }}>
              <button
                type="submit"
                className="font-custom btn btn-block bg-primary text-white cursor-not-allowed rounded-[30px]"
                disabled={btn_disable}
              >
                Get Started
              </button>
            </div>
          </form>
        </div>
        <Footer bottom={4} />
      </div>
    </>
  );
};
export default Signup;
